import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import CustomTimePicker from "./CustomTimePicker";

export default function WeeklyTimeSelector({ scheduleProp, onScheduleChange }) {
  const days = [
    { label: "Monday", value: "mon" },
    { label: "Tuesday", value: "tue" },
    { label: "Wednesday", value: "wed" },
    { label: "Thursday", value: "thu" },
    { label: "Friday", value: "fri" },
    { label: "Saturday", value: "sat" },
    { label: "Sunday", value: "sun" },
  ];
  const { t } = useTranslation();

  // Convert array → object
  const [schedule, setSchedule] = useState(() => {
    const obj = {};
    days.forEach((d) => {
      const found = scheduleProp?.find((x) => x.day === d.value);
      obj[d.value] = found
        ? {
            enabled: found?.day !== "" && found?.time !== "" && true,
            time: found.time,
          }
        : { enabled: false, time: "" };
    });
    return obj;
  });

  // send updated array format to parent (only when schedule changes)
  useEffect(() => {
    const list = Object.entries(schedule).map(([day, v]) => ({
      day,
      time: v.time,
      enabled: v.enabled,
    }));
    onScheduleChange && onScheduleChange(list);
  }, [schedule]);

  // toggle and update time
  const toggleDay = (day) => {
    setSchedule((prev) => ({
      ...prev,
      [day]: { ...prev[day], enabled: !prev[day].enabled },
    }));
  };

  const updateTime = (day, value) => {
    setSchedule((prev) => ({
      ...prev,
      [day]: { ...prev[day], time: value },
    }));
  };

  return (
    <div className="w-100">
      <label className="mb-2" style={{ fontSize: "14px", color: "#9E9E9E" }}>
        {t("Weekly — On days and Time")}
      </label>
      {days.map((day) => (
        <div
          key={day.value}
          className="d-flex align-items-center justify-content-between mb-3"
          style={{ height: "35px" }}
        >
          <div className="d-flex align-items-center gap-2">
            <div className="form-check form-switch ps-0">
              <input
                className="form-check-input ms-0"
                type="checkbox"
                checked={schedule[day.value].enabled}
                onChange={() => toggleDay(day.value)}
                style={{ cursor: "pointer" }}
              />
            </div>
            <span>{day.label}</span>
          </div>

          {schedule[day.value].enabled && (
            // <input
            //   type="clock"
            //   className="form-control"
            //   style={{ width: "120px" }}
            //   value={schedule[day.value].time}
            //   onChange={(e) => updateTime(day.value, e.target.value)}
            //   placeholder="HH:MM"
            // />
            <CustomTimePicker
              value={schedule[day.value].time}
              onChange={(val) => updateTime(day.value,val)}
            />
          )}
        </div>
      ))}
      <p className="mt-2" style={{ fontSize: "12px", color: "#C0C0C0" }}>
        {t(
          "Multiple days can be selected (used when the recurring setting is set to weekly)."
        )}
      </p>
      <hr />
    </div>
  );
}
